import React from 'react';

import JumboCta from 'js/src/components/common/JumboCta';

const CareersListings = React.memo(function CareersListings() {
    React.useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://boards.greenhouse.io/embed/job_board/js?for=lumen5';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div className="careers-overview">
            <div className="section section-1">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-sm-12">
                            <h5 className="text-center text-uppercase">CAREERS</h5>
                            <div className="d-flex flex-column my-l5-16">
                                <h3 className="text-center">
                                    We&apos;re on a mission to make video creation simpler, faster
                                    and more intuitive — for everyone.
                                </h3>
                            </div>
                        </div>
                    </div>

                    {/* grnhse_app IS WHERE GREENHOUSE WILL INJECT THE JOB BOARD */}
                    <div id="grnhse_app"></div>
                    {/* END GREENHOUSE INTEGRATION */}
                </div>
            </div>
            <div className="mb-l5-48">
                <JumboCta
                    header="Join over 5,000,000 companies using Lumen5 to tell their stories."
                    body="Lumen5 is a video creation software that helps marketers, publishers, and brands create video content in a breeze, without any technical expertise."
                />
            </div>
        </div>
    );
});

export default CareersListings;
